import { junipProductGroups } from 'lib/constants/junipProductGroups';

export const getRootProductSlug = (
  productChoices: string[],
  slug: string,
): string | undefined => {
  /* If the slug is in the product choices, we can just return it we can just return it */
  if (productChoices.includes(slug)) {
    return slug;
  }

  /* We look through the product groups related slugs
   * If we find a match, we get the root slug in the group
   * We then check if the root slug is in the product choices
   * If it is, we return the root slug
   */
  for (const [rootSlug, relatedSlugs] of Object.entries(junipProductGroups)) {
    if (relatedSlugs.includes(slug) && productChoices.includes(rootSlug)) {
      return rootSlug;
    }
  }

  /* If we can't find it with the above logic
   * it is either not in the product choices
   * or not part of a group, so we return undefined
   */
  return undefined;
};
